export default __webpack_public_path__ + "static/media/LOGO.cf896ec4.png";